export const INTRO_CONSTANTS = {
  title: "Infrastructure That Scales With You",
  text: "Say goodbye to unpredictable cloud costs and rigid pricing tiers. OneMind delivers scalable, cost-efficient infrastructure designed for modern engineering teams. Build faster, scale smarter, and only pay for what you actually use.",
  btnText: "Explore Pricing Plans",
};
